// libraries
import React from "react";
import { useHistory } from "react-router-dom";

// animation
import FadeTop from "src/components/Animation/FadeTop";

// styles
import styles from "./styles.module.scss";

const BecomeEventmooner = () => {
  // history
  const history = useHistory();

  return (
    <FadeTop duration={0.5}>
      <div className={styles.become}>
        <h1>Become a Eventmooner</h1>
        <p>
          <span onClick={() => history.push("/register")}>Log in</span> to save
          your notifications or <span>click here to sync</span> your events to
          the app
        </p>
      </div>
    </FadeTop>
  );
};

export default BecomeEventmooner;
